import { render, staticRenderFns } from "./FloorDetection.vue?vue&type=template&id=ce1d08f8&scoped=true&"
import script from "./FloorDetection.vue?vue&type=script&lang=js&"
export * from "./FloorDetection.vue?vue&type=script&lang=js&"
import style0 from "./FloorDetection.vue?vue&type=style&index=0&id=ce1d08f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1d08f8",
  null
  
)

export default component.exports